import { BlogSection } from '@/types/blog';

export const radikaleAkzeptanz: BlogSection = {
  id: 'radikale-akzeptanz',
  title: 'Das Upgrade: Radikale Akzeptanz als Betriebssystem',
  content: `
    <p class="mb-4">
      Die Lösung ist kein besseres positives Denken. Die Lösung ist ein komplettes Upgrade. Wir nennen es <strong>Radikale Akzeptanz</strong>.
    </p>
    
    <p class="mb-4">
      Dieses Konzept, maßgeblich geprägt durch die Psychologin Marsha Linehan (DBT) und die Meditationslehrerin Tara Brach, ist keine passive Resignation. Es ist die mutige, totale Anerkennung der Realität als einzigem Startpunkt für Veränderung.
    </p>
    
    <p class="mb-4">
      Es bedeutet, die Warnlampe anzusehen und zu sagen: "Okay, die Lampe leuchtet. Das ist ein Fakt. Lasst uns die Daten analysieren."
    </p>
    
    <div class="mb-4 p-4 bg-joerg-50 dark:bg-joerg-900/20 rounded-lg">
      <p class="mb-3"><strong>Praxisbeispiel:</strong> Du erhältst hartes, aber faires Feedback von einem Kunden.</p>
      
      <p class="mb-2"><strong>Altes System (Positives Denken):</strong> "Der Kunde ist nur negativ. Ich konzentriere mich auf meine Stärken." → Daten werden ignoriert.</p>
      
      <p class="mb-0"><strong>Neues System (Radikale Akzeptanz):</strong> "Okay, dieses Feedback existiert. Es fühlt sich unangenehm an – das ist eine valide emotionale Reaktion (Selbstmitgefühl nach Kristin Neff). Was genau ist die Information in dieser Kritik? Welcher meiner Werte wird hier berührt? (Emotionale Agilität nach Susan David)." → Daten werden integriert.</p>
    </div>
    
    <p class="mb-4">
      Radikale Akzeptanz ist die Kernkompetenz. Sie ermöglicht es dir, aufzuhören, Krieg gegen dich selbst zu führen, und stattdessen zum neugierigen Programmierer deines eigenen Systems zu werden.
    </p>
  `
};
